import { NgModule } from '@angular/core';
import { CoHeaderDirective } from './co-header/co-header';
import { NavPageDirective } from './nav-page/nav-page';
import { NavScreenDirective } from './nav-screen/nav-screen';
import { CoCoverFallbackDirective } from './co-cover-fallback/co-cover-fallback';
import { CheckRegistrationDirective } from './check-registration/check-registration';
import { RegistrationMessageDirective } from './registration-message/registration-message';
import { CoEventImageFallbackDirective } from './co-event-image-fallback/co-event-image-fallback';
import { ScrollArrowsDirective } from './scroll-arrows/scroll-arrows';
import { LoginHeaderDirective } from './login-header/login-header';
import { LogoutHeaderDirective } from './logout-header/logout-header';
import { CatchLinksDirective } from './catch-links/catch-links';
import { CoHideBackButtonDirective } from './co-hide-back-button/co-hide-back-button';
import { CoMenuToggleDirective } from './co-menu-toggle/co-menu-toggle';
import { DomObserverDirective } from './dom-observer/dom-observer';
import { CoDigitalIconDirective } from './co-digital-icon/co-digital-icon';
import { CoKeyboardNumericCharsDirective } from './keyboard-numeric-chars/keyboard-numeric-chars';
import { CoInputScannerDirective } from './input-scanner/input-scanner';
@NgModule({
	declarations: [CoHeaderDirective,
    NavPageDirective,
    NavScreenDirective,
    CoCoverFallbackDirective,
    CheckRegistrationDirective,
    RegistrationMessageDirective,
    CoEventImageFallbackDirective,
    ScrollArrowsDirective,
    LoginHeaderDirective,
    LogoutHeaderDirective,
    CatchLinksDirective,
    CoHideBackButtonDirective,
    CoMenuToggleDirective,
    DomObserverDirective,
    CoDigitalIconDirective,
    CoKeyboardNumericCharsDirective,
    CoInputScannerDirective],
	imports: [],
	exports: [CoHeaderDirective,
    NavPageDirective,
    NavScreenDirective,
    CoCoverFallbackDirective,
    CheckRegistrationDirective,
    RegistrationMessageDirective,
    CoEventImageFallbackDirective,
    ScrollArrowsDirective,
    LoginHeaderDirective,
    LogoutHeaderDirective,
    CatchLinksDirective,
    CoHideBackButtonDirective,
    CoMenuToggleDirective,
    DomObserverDirective,
    CoDigitalIconDirective,
    CoKeyboardNumericCharsDirective,
    CoInputScannerDirective]
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts